<template lang="pug">
.main-item
  .collapse.show(
    :id="'league-' + source.id"
    :aria-labelledby="source.id"
  )
    .card-body.p-0
      .match.outright(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
        swiper(ref="sw" :options="swiperOptions" @slideChange="handleSlideChange")
          //- template(v-if="source.matchList.length > 8")
          template(v-for="(a,b) in Math.ceil(source.matchList.length/itemPerRows)")
            swiper-slide.match-marketgroup-content(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
              .match-bet-area-group
                .match-bet-area-type
                  .match-odd-area
                    .match-odd-area-group
                      template(v-for="option in source.matchList.slice(b*itemPerRows, (b+1)*itemPerRows)")
                        template(v-if="option.details.orz")
                          OddsItem(:odds="option.details.orz[0]" idx=5 :typ="oddsType" dataType="4" mode="orz" count=0 :label="option.matchBody[5]" :details="option.details.orz")
            .swiper-pagination(slot="pagination")

</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem
  },
  mixins: [mixinHDPOUOdds],
  data() {
    return {
      activeIndex: 0,
      itemPerRows: 3,
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.sw ? this.$refs.sw.$swiper : 0;
    }
  },
  mounted() {
    this.activeIndex = this.swiper.activeIndex;
    this.$nextTick(() => {
      this.initOrzCollapseState();
    });
  },
  methods: {
    initOrzCollapseState() {
      const collapseEl = this.$el.querySelector('.collapse');
      if (!collapseEl || collapseEl.dataset.orzInitialized) {
        return;
      }
      if (!collapseEl.querySelector('.match.outright')) {
        return;
      }

      collapseEl.dataset.orzInitialized = 'true';

      const container = document.getElementById('all-leagues');
      if (!container) {
        return;
      }

      const firstOrz = container.querySelector('.match.outright');
      const firstOrzCollapse = firstOrz && firstOrz.closest('.collapse');
      if (!firstOrzCollapse || firstOrzCollapse === collapseEl) {
        return;
      }

      collapseEl.classList.remove('show');
      const header = container.querySelector('.collapse-head[data-target="#' + collapseEl.id + '"]');
      if (header) {
        header.classList.add('collapsed');
        header.setAttribute('aria-expanded', 'false');
      }

      $(collapseEl).on('shown.bs.collapse', () => {
        if (this.swiper && this.swiper.update) {
          this.swiper.update();
        }
      });
    },
    handleSlideChange() {
      this.activeIndex = this.swiper.activeIndex;
    }
  }
};
</script>